/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

function loadScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {
        //IE
        script.onreadystatechange = function () {
            if (script.readyState == 'loaded' || script.readyState == 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        //Others
        script.onload = function () {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
}

function loadScriptArr(urlArr, callback) {
    var len = urlArr.length;
    if (len === 0) {
        typeof callback === 'function' && callback();
        return;
    }
    var loadedCount = 0;
    urlArr.map(function (v) {
        loadScript(v, function () {
            if (++loadedCount === len) {
                typeof callback === 'function' && callback();
            }
        });
    });
}

function loadCaptchaScripts(isH5, callback) {
    var urlArr = [];
    if (isH5) {
        urlArr.push('//g.alicdn.com/mtb/lib-flexible/0.3.4/??flexible_css.js,flexible.js');
    }
    urlArr.push('//g.alicdn.com/sd/smartCaptcha/0.0.4/index.js', '//g.alicdn.com/sd/nvc/1.1.112/guide.js', '//g.alicdn.com/sd/quizCaptcha/0.0.1/index.js');

    loadScriptArr(urlArr, callback);
}

function initCaptcha(_ref, resetReceiver) {
    var isH5 = _ref.isH5,
        width = _ref.width,
        height = _ref.height,
        _success = _ref.success,
        _fail = _ref.fail,
        renderTo = _ref.renderTo;

    window.NVC_Opt = {
        //应用类型标识。它和使用场景标识（scene字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
        appkey: 'FFFF0N000000000076F1',
        //使用场景标识。它和应用类型标识（appkey字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在人机验证控制台的配置管理页签找到对应的scene值，请务必正确填写。
        scene: isH5 ? 'ic_message_h5' : 'ic_message',
        //声明二次验证需要渲染的目标元素ID。
        renderTo: renderTo,
        //当唤醒刮刮卡验证作为二次验证时，配置需要刮出的两个elements的图片资源。
        elements: ['//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png', '//img.alicdn.com/tfs/TB17cwllsLJ8KJjy0FnXXcFDpXa-50-74.png'],
        //当唤醒刮刮卡验证作为二次验证时，配置刮动时的背景图像（自动应用平铺填充的方式）。
        bg_back_prepared: '//img.alicdn.com/tps/TB1skE5SFXXXXb3XXXXXXXXXXXX-100-80.png',
        //当唤醒刮刮卡验证作为二次验证时，配置刮动时的前景图像（仅支持base64数据流）。
        bg_front: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABQCAMAAADY1yDdAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAADUExURefk5w+ruswAAAAfSURBVFjD7cExAQAAAMKg9U9tCU+gAAAAAAAAAIC3AR+QAAFPlUGoAAAAAElFTkSuQmCC',
        //当唤醒刮刮卡验证作为二次验证时，配置验证通过时显示的图标资源。
        obj_ok: '//img.alicdn.com/tfs/TB1rmyTltfJ8KJjy0FeXXXKEXXa-50-74.png',
        //当唤醒刮刮卡验证作为二次验证时，配置验证通过时显示的背景图像（自动应用平铺填充的方式）。
        bg_back_pass: '//img.alicdn.com/tfs/TB1KDxCSVXXXXasXFXXXXXXXXXX-100-80.png',
        //当唤醒刮刮卡验证作为二次验证时，配置验证失败或异常时显示的图标资源。
        obj_error: '//img.alicdn.com/tfs/TB1q9yTltfJ8KJjy0FeXXXKEXXa-50-74.png',
        //当唤醒刮刮卡验证作为二次验证时，配置验证失败或异常时显示的背景图像（自动应用平铺填充的方式）。
        bg_back_fail: '//img.alicdn.com/tfs/TB1w2oOSFXXXXb4XpXXXXXXXXXX-100-80.png',
        //当唤醒刮刮卡验证作为二次验证时，用于自定义文案。详细配置方法请参见自定义文案文档。
        upLang: { 'cn': {
                _ggk_guide: '请摁住鼠标左键，刮出两面盾牌',
                _ggk_success: '恭喜您成功刮出盾牌<br/>继续下一步操作吧',
                _ggk_loading: '加载中',
                _ggk_fail: ['呀，盾牌不见了<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', 'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN', '反馈问题'],
                _ggk_action_timeout: ['我等得太久啦<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', 'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN', '反馈问题'],
                _ggk_net_err: ['网络实在不给力<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', 'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN', '反馈问题'],
                _ggk_too_fast: ['您刮得太快啦<br/>请', 'javascript:noCaptcha.reset()', '再来一次', '或', 'http://survey.taobao.com/survey/QgzQDdDd?token=%TOKEN', '反馈问题']
            }
        }
    };
    loadCaptchaScripts(isH5, function () {
        // eslint-disable-next-line
        var ic = new smartCaptcha({
            //声明智能验证需要渲染的目标元素ID。
            renderTo: renderTo,
            //智能验证组件的宽度。
            width: width,
            //智能验证组件的高度。
            height: height,
            //智能验证组件初始状态文案。
            default_txt: '点击按钮开始智能验证',
            //智能验证组件验证通过状态文案。
            success_txt: '验证成功',
            //智能验证组件验证失败（拦截）状态文案。
            fail_txt: '验证失败，请在此点击按钮刷新',
            //智能验证组件验证中状态文案。
            scaning_txt: '智能检测中',
            //前端智能验证通过时会触发该回调参数。您可以在该回调参数中将请求标识（token）、会话ID（sessionid）、签名串（sig）字段记录下来，随业务请求一同发送至您的服务端调用验签。
            success: function success(data) {
                _success && _success({
                    token: window.NVC_Opt.token,
                    sessionId: data.sessionId,
                    sig: data.sig
                });
            },
            fail: function fail() {
                _fail && _fail();
            }
        });
        ic.init();
        typeof resetReceiver === 'function' && resetReceiver(ic.reset.bind(ic));
    });
}

module.exports = {
    initCaptcha: initCaptcha
};



/*****************
 ** WEBPACK FOOTER
 ** ./application/helper/captcha.js
 ** module id = 177
 ** module chunks = 1
 **/